/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-console */
/* eslint-disable camelcase */
import {
  Box,
  Group,
  Space,
  TextInput,
  ActionIcon,
  Button,
  Text,
  Divider,
  Container,
  Center,
  Stack,
} from '@mantine/core';
import dayjs from 'dayjs';
import { DataTable } from 'mantine-datatable';
import { useDebouncedValue } from '@mantine/hooks';
import { CSVLink } from 'react-csv';
import { useEffect, useState } from 'react';
import sortBy from 'lodash/sortBy';
import { Search, Download } from 'tabler-icons-react';
import { sendRequest } from '../../services/services';
import LandingLayout from '../../components/LandingLayout';
import { renderCSVData } from '../../utils/utils';

const History = () => {
  const [sortStatus, setSortStatus] = useState({ direction: 'desc' });

  const PAGE_SIZE = 10;

  const [page, setPage] = useState(1);

  const [results, setResults] = useState([]);
  const [, setTotalRecords] = useState([]);
  const [records, setRecords] = useState(results.slice(0, PAGE_SIZE));

  const limit = `?limit=100000000&offset=0`;
  useEffect(() => {
    sendRequest(`/cashier/${limit}`, 'get').then((res) => {
      setResults(res?.data.sort((a, b) => a - b) || []);
    });
  }, [limit]);

  useEffect(() => {
    const from = (page - 1) * PAGE_SIZE;
    const to = from + PAGE_SIZE;
    setRecords(results.slice(from, to));
    setTotalRecords(results?.length);
  }, [page, results]);

  // Search //
  const [query, setQuery] = useState('');
  const [debouncedQuery] = useDebouncedValue(query, 200);
  useEffect(() => {
    setRecords(
      results.filter(({ pass_id, amount, invoice_id }) => {
        if (
          debouncedQuery !== '' &&
          !`${pass_id} ${amount} ${invoice_id}`
            .toLowerCase()
            .includes(debouncedQuery.trim().toLowerCase())
        ) {
          return false;
        }
        return true;
      }),
    );
  }, [debouncedQuery]);

  // Sorting //
  useEffect(() => {
    const data = sortBy(results, sortStatus.columnAccessor);
    setRecords(sortStatus.direction === 'desc' ? data.reverse() : data);
  }, [sortStatus]);

  const [csvLink, setCsvLink] = useState('');

  const columns = [
    { accessor: 'pass_id', title: 'Ticket Id', width: 100, sortable: true },
    { accessor: 'amount', title: 'Amount (SAR)', width: 100, sortable: true },
    {
      accessor: 'payment_types.name',
      title: 'Payment Type',
      width: 100,
      sortable: true,
    },
    {
      accessor: 'invoice_id',
      title: 'Invoice Id ',
      width: 100,
      sortable: true,
    },
    {
      accessor: 'updated_at',
      title: 'Transaction Time',
      width: 100,
      sortable: true,
    },
  ];

  const onDownload = () => {
    csvLink.link.click();
    // const data = records;
    // if (data) {
    //   setCsvData(renderCSVData(data, columns));
    //   console.log('aaa', csvData);
    //   csvLink.link.click();
    // }
  };
  const dataDownload =
    renderCSVData(
      records.map((row) => ({
        ...row,
        updated_at: dayjs(row?.updated_at).format('MM/DD/YYYY	 h:mm A'),
      })),
      columns,
    ) || [];

  // Print History

  const [profile, setProfile] = useState({});

  const fetchProfile = () => {
    sendRequest(`cashier/profile`, 'get')
      .then((res) => {
        setProfile(res?.data || []);
      })

      .catch((err) => {
        if (err?.response?.data?.code) {
          // eslint-disable-next-line no-console
          console.log('err', err?.response?.data?.code);
        }
      });
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  const printHistory = () => {
    window.print();
  };

  const sumByType = records.reduce((acc, curr) => {
    if (!acc[curr?.payment_types?.name]) {
      acc[curr?.payment_types?.name] = 0;
    }
    acc[curr?.payment_types?.name] += curr?.amount;
    return acc;
  }, {});
  console.log('records', sumByType);
  const totalAmount = records.reduce((acc, curr) => acc + curr.amount, 0);

  return (
    <LandingLayout>
      <Space h="xl" />
      <Space h="xs" />
      <Box className="no-printme">
        <Group>
          <TextInput
            sx={{ flexBasis: '60%' }}
            placeholder="Search Ticket Id & Invoice Id"
            icon={<Search size={16} />}
            value={query}
            onChange={(e) => setQuery(e.currentTarget.value)}
            py="xl"
          />
          <ActionIcon size="md" variant="filled" onClick={onDownload}>
            <Download size={30} />
          </ActionIcon>
          <Button onClick={() => printHistory()} color="blue">
            Print History
          </Button>
        </Group>
        <CSVLink
          data={dataDownload}
          filename={`History-${dayjs().format('MM/DD/YYYY	 h:mm A')}.csv`}
          className="hidden"
          ref={(r) => setCsvLink(r)}
          target="_blank"
        />
        <DataTable
          withBorder
          withColumnBorders
          records={records}
          columns={[
            {
              accessor: 'pass_id',
              title: 'Ticket Id',
              width: 100,
              sortable: true,
            },
            {
              accessor: 'amount',
              title: 'Amount (SAR)',
              width: 100,
              sortable: true,
            },
            {
              accessor: 'payment_types.name',
              title: 'Payment Type',
              width: 100,
              sortable: true,
            },
            {
              accessor: 'invoices.invoice_number',
              title: 'Invoice Number ',
              width: 100,
              sortable: true,
            },
            {
              accessor: 'updated_at',
              title: 'Transaction Time',
              width: 100,
              sortable: true,
              render: ({ updated_at }) => dayjs(updated_at).format('MM/DD/YYYY	 h:mm A'),
            },
          ]}
          totalRecords={results.length}
          recordsPerPage={PAGE_SIZE}
          page={page}
          onPageChange={(p) => setPage(p)}
          sortStatus={sortStatus}
          direction="desc"
          onSortStatusChange={setSortStatus}
        />
      </Box>
      <Box>
        <Container className="printme">
          <Center>
            <Text weight={500} py="sm">
              Hyperthings
            </Text>
          </Center>
          <Group position="apart" py="sm">
            <Text weight={500}>Cashier Name</Text>
            <Text weight={500}>{profile?.name}</Text>
          </Group>

          <Group position="apart" py="sm">
            <Text weight={500}>Site</Text>
            <Text weight={500}>
              {profile?.user__site__assign?.filter((item) => item?.is_active)[0]?.sites?.name}
            </Text>
          </Group>

          <Group position="apart" py="sm">
            <Text weight={500}>Operation</Text>
            <Text weight={500}>{results.length}</Text>
          </Group>
          <Divider my="sm" variant="dotted" />
          <Stack>
            <Group position="apart">
              <Stack>
                <Text weight={700} size="sm">
                  Invoice No
                </Text>
                {records.map((element) => (
                  <Text>{element?.invoice_id}</Text>
                ))}
              </Stack>
              <Stack>
                <Text weight={700} size="sm">
                  Amount
                </Text>
                {records.map((element) => (
                  <Text>{element?.amount}</Text>
                ))}
              </Stack>
              <Stack>
                <Text weight={700} size="sm">
                  Payment Method
                </Text>
                {records.map((element) => (
                  <Text>{element?.payment_types?.name ? element?.payment_types?.name : '-'}</Text>
                ))}
              </Stack>
            </Group>
          </Stack>
          <Group position="apart" py="sm">
            <Text weight={500}>Total Cash Amount</Text>
            <Text weight={500}>{Number(sumByType?.Cash ? sumByType?.Cash : 0).toFixed(2)}</Text>
          </Group>
          <Group position="apart" py="sm">
            <Text weight={500}>Total Card Amount</Text>
            <Text weight={500}>{Number(sumByType?.Card ? sumByType?.Card : 0).toFixed(2)}</Text>
          </Group>
          <Divider my="sm" variant="dotted" />

          <Group position="apart" py="sm">
            <Text weight={500}>Accounting Summary</Text>
            <Text weight={500}>{Number(totalAmount).toFixed(2)}</Text>
          </Group>
        </Container>
      </Box>
    </LandingLayout>
  );
};
export default History;
